import { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../state/AuthContext.jsx';
import { useNotice } from '../../state/NoticeContext.jsx';
import { Button, Card, Text } from '../../ui.jsx';

export default function SignIn() {
  const { signIn } = useAuth();
  const notice = useNotice();
  const navigate = useNavigate();
  const location = useLocation();
  const [form, setForm] = useState({ email: '', password: '' });
  const [busy, setBusy] = useState(false);

  const submit = async (event) => {
    event.preventDefault();
    setBusy(true);
    try {
      const user = await signIn(form.email.trim(), form.password);
      notice.success(`Welcome back, ${user.name.split(' ')[0]}.`);
      navigate(user.role === 'student' ? location.state?.from || '/match' : '/admin', { replace: true });
    } catch (error) {
      notice.fromError(error);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="authw">
      <Card>
        <h1 style={{ fontSize: 24, marginBottom: 4 }}>Log in</h1>
        <p className="mu" style={{ marginBottom: 16 }}>
          Applicants and college staff use the same sign-in.
        </p>
        <form onSubmit={submit}>
          <Text
            label="Email"
            type="email"
            required
            autoComplete="email"
            value={form.email}
            onChange={(e) => setForm({ ...form, email: e.target.value })}
          />
          <div style={{ height: 12 }} />
          <Text
            label="Password"
            type="password"
            required
            autoComplete="current-password"
            value={form.password}
            onChange={(e) => setForm({ ...form, password: e.target.value })}
          />
          <div style={{ height: 16 }} />
          <Button type="submit" busy={busy} style={{ width: '100%' }}>Log in</Button>
        </form>
        <p className="mu" style={{ marginTop: 16, textAlign: 'center' }}>
          <Link to="/forgot-password">Forgot your password?</Link>
        </p>
        <p className="mu" style={{ textAlign: 'center' }}>
          New to Entrance? <Link to="/signup">Create an account</Link>
        </p>
      </Card>
    </div>
  );
}
